module.exports = __webpack_public_path__ + "img/update-red.0685d0cc.svg";